import { Box, Typography } from '@mui/material';

/**
 * Centered empty-state content for the gen-3 cohort detail tabs ("No SQL",
 * "Cohort not processed", …). Sits inside the tab's outlined card; sharing
 * one component keeps the SQL and Results empty states identical in size and
 * typography.
 */
export const TabEmptyState = ({
  title,
  message,
  'data-testid': dataTestId,
}: {
  title: string;
  message: string;
  'data-testid'?: string;
}) => (
  <Box
    data-testid={dataTestId}
    sx={{
      minHeight: 280,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      gap: 1,
    }}
  >
    <Typography variant="h5">{title}</Typography>
    <Typography variant="body1" color="text.secondary">
      {message}
    </Typography>
  </Box>
);
